<!-- Header -->
<div class="flex items-center justify-between px-3 sm:px-4 py-2 sm:py-3 border-b border-slate-200">
  <h2 class="text-sm sm:text-base font-bold tracking-widest uppercase text-slate-800 m-0">
    Quotation Details - {{ data?.transactionNo }}
  </h2>
  <button mat-icon-button mat-dialog-close class="text-slate-600 hover:text-rose-600 scale-100" matTooltip="Close">
    <mat-icon fontSet="material-icons" class="font-bold">close</mat-icon>
  </button>
</div>

<mat-dialog-content class="mat-typography custom-scrollbar overflow-x-hidden min-w-[400px] md:min-w-[600px]">
  <form #quotationForm="ngForm" class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-2 sm:mt-3">
      
      <!-- Business Name -->
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Business Name</mat-label>
        <mat-select [(ngModel)]="quotationData.businessName" name="businessName" placeholder="Select Business Name" required>
          <mat-option value="Riddhi Siddhi Services">Riddhi Siddhi Services</mat-option>
          <mat-option value="MB Cleaning Services">MB Cleaning Services</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Work Order No -->
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Work Order No</mat-label>
        <input matInput [(ngModel)]="quotationData.workOrderNo" name="workOrderNo" placeholder="Enter Work Order No" >
      </mat-form-field>

      <!-- Working Date -->
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Working Dates</mat-label>
        <input matInput [(ngModel)]="quotationData.workingDate" name="workingDate" placeholder="Enter Working Dates" >
      </mat-form-field>

      <!-- Worksite -->
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Worksite</mat-label>
        <input matInput [(ngModel)]="quotationData.worksite" name="worksite" placeholder="Enter Worksite" >
      </mat-form-field>

      <!-- Quotation Print Date -->
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Quotation Print Date</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="quotationData.quotationPrintDate" name="quotationPrintDate" placeholder="Choose a date" required>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <!-- To Customer Address -->
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>To Customer Address</mat-label>
        <textarea matInput [(ngModel)]="quotationData.toCustomerAddress" name="toCustomerAddress" rows="1" class="resize-none" placeholder="Enter customer full address..." required></textarea>
      </mat-form-field>

      <!-- Dynamic Terms & Conditions -->
      <div class="border border-slate-300 rounded-lg p-3 bg-slate-50 sm:col-span-2">
        <div class="flex items-center justify-between mb-1">
          <mat-label class="text-[11px] font-bold tracking-widest uppercase text-slate-800">Terms & Conditions</mat-label>
          <button type="button" mat-icon-button (click)="addTc()" matTooltip="Add Term" class="text-indigo-600">
            <mat-icon class="text-sm">add_circle</mat-icon>
          </button>
        </div>

        <div class="flex flex-col gap-1">
          <div *ngFor="let tc of quotationData.quotationTc; let i = index; trackBy: trackByIndex" class="flex items-center gap-2">
            <mat-form-field appearance="outline" class="w-full flex-1 mb-[-1.25em]">
              <mat-label>Term {{ i + 1 }}</mat-label>
              <input matInput [(ngModel)]="quotationData.quotationTc[i]" name="tc_{{i}}" placeholder="e.g. 70% payment in advance" required>
            </mat-form-field>
            <button type="button" mat-icon-button (click)="removeTc(i)" matTooltip="Remove Term" class="text-rose-600">
              <mat-icon class="text-sm">remove_circle</mat-icon>
            </button>
          </div>
          <div *ngIf="quotationData.quotationTc.length === 0" class="text-xs text-slate-500 italic mt-2">
            No terms and conditions added yet.
          </div>
        </div>
      </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions class="flex flex-col-reverse sm:flex-row sm:justify-end px-4 py-3 border-t border-slate-200 gap-3 sm:gap-2 box-border">
  <button type="button" mat-dialog-close
    class="w-full sm:w-auto px-3 py-2 rounded-md border border-slate-300 text-slate-600 text-xs font-bold tracking-widest uppercase hover:bg-slate-50 transition-colors">
    Cancel
  </button>
  <button type="button" (click)="save()" [disabled]="quotationForm?.invalid"
    class="w-full sm:w-auto px-3 py-2 rounded-md bg-slate-900 text-white text-xs font-bold tracking-widest uppercase shadow-md hover:bg-slate-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
    Save & Print
  </button>
</mat-dialog-actions>
